<template>
  <LvTextCard class="lv-state-ques-condition">
    <template v-slot:content>
      <LvFlexBox alignItems="start" class="lv-state-ques-condition__section-wrap">
        <div class="lv-state-ques-condition__delete top">
          <LvText h3 :red="!isSort" :blue="isSort" @click="$_onClickIcon()"><i :class="_icon"/></LvText>
        </div>
        <LvFlexBox noWrap class="lv-state-ques-condition__section">
          <LvText h5 noWrap class="mr-8">{{ $t('當') }}</LvText>
          <DropdownMenuButton
            :value="operator"
            outline
            required
            rules="required"
            :disabled="isSort"
            :dropdownMenuItem="operatorItems"
            class="mr-8 lv-state-ques-condition__dropdown"
            @input="$_onInput($event, 'operator')"
          />
        </LvFlexBox>
        <LvFlexBox noWrap class="lv-state-ques-condition__section">
          <StateInputButton
            :value="lowVal"
            required
            type="number"
            rules="required"
            placeholder="請輸入數值"
            :disabled="isSort"
            class="mr-8 lv-state-ques-condition__input"
            @input="$_onInput($event, 'lowVal')"
          />
          <LvText
            v-if="operator === 'in' || operator === 'not_in'"
            h5
            noWrap
            class="mr-8"
          >{{ $t('與') }}</LvText>
          <StateInputButton
            v-if="operator === 'in' || operator === 'not_in'"
            :value="highVal"
            required
            type="number"
            rules="required"
            placeholder="請輸入數值"
            :disabled="isSort"
            class="mr-8 lv-state-ques-condition__input"
            @input="$_onInput($event, 'highVal')"
          />
        </LvFlexBox>
        <LvFlexBox noWrap class="lv-state-ques-condition__section">
          <LvText h5 noWrap class="mr-8">{{ $t('符合') }}</LvText>
          <DropdownMenuButton
            :value="risk"
            outline
            required
            rules="required"
            placeholder="風險等級"
            :disabled="isSort"
            :dropdownMenuItem="riskItems"
            class="mr-8 lv-state-ques-condition__dropdown"
            @input="$_onInput($event, 'risk')"
          />
        </LvFlexBox>
        <div class="lv-state-ques-condition__delete right">
          <LvText h3 :red="!isSort" :blue="isSort" @click="$_onClickIcon()"><i :class="_icon"/></LvText>
        </div>
      </LvFlexBox>
    </template>
  </LvTextCard>
</template>

<script>
import Spare_checklist from '@/spare/checklist';

export default {
  props: {
    operator: {
      type: String,
    },
    lowVal: {
      type: String,
    },
    highVal: {
      type: String,
    },
    risk: {
      type: String,
    },
    isSort: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      riskItems: Spare_checklist.riskItems,
      operatorItems: Spare_checklist.operatorItems,
    }
  },
  computed: {
    _icon() {
      return this.isSort ? 'icon-drag' : 'icon-delete';
    }
  },
  methods: {
    $_onInput($event, type) {
      this.$emit('input', {type, value: $event});
    },
    $_onClickIcon() {
      if (this.isSort) return;
      this.$emit('delete');
    },
  }
}
</script>